<ng-container>
    <app-update-banner
        *ngIf="isVersionMismatch"
        style="margin-bottom: 16px"
        messageLocalizationKey="aumico_notes_update_banner_message"
    >
    </app-update-banner>
    <div class="notes-container__actions">
        <div class="notes-container__actions">
            <ham-button
                outline="true"
                icon="assets/hamIcons/file-copy-outline.svg"
                (click)="onCopyNotesStructureFromAnotherAnnualReportButtonClicked()"
            >
                {{ 'aumico_copy_notes_structure_from_another_annual_report' | i18next }}</ham-button
            >

            <ham-button
                color="primary"
                icon="assets/hamIcons/plus-outline.svg"
                (click)="openAddNewNotesAccordionSection()"
            >
                {{ 'aumico_add_notes_button' | i18next }}</ham-button
            >
        </div>
    </div>

    <div class="content">
        <div class="accordions-section">
            <ham-accordion
                *ngIf="notesAccordionData.length > 0 && outputtedAnnualAccordionsData != null"
                cdkDropList
                (cdkDropListDropped)="drop($event)"
            >
                <ham-accordion-item
                    cdkDrag
                    *ngFor="let noteAccordion of notesAccordionData; let accordionIndex = index"
                    [cdkDragStartDelay]="50"
                    (cdkDragStarted)="onDragStarted($event, accordionIndex)"
                    (cdkDragEnded)="onDragEnded($event)"
                    [isDragging]="draggingAccordionIndex === accordionIndex"
                    [cdkDragPreviewClass]="'drag-preview-class'"
                    [isOpened]="openAccordions[noteAccordion.name]"
                    (opened)="onAccordionExpand(accordionIndex)"
                    (closed)="onAccordionClosed(accordionIndex)"
                    (toggle)="toggleAccordion(noteAccordion.name)"
                    #accordions
                >
                    <!-- Placeholder element -->
                    <ng-template cdkDragPlaceholder>
                        <div class="accordion-placeholder">
                            <!-- Placeholder content, styled with the same height as the dragged item -->
                        </div>
                    </ng-template>
                    <!-- Header Content -->
                    <div
                        accordion-header
                        [ngClass]="{ 'accordion-header--all-hidden': isAccordionHidden(noteAccordion) }"
                    >
                        <ng-container>
                            <div class="accordion-header-content">
                                <span cdkDragHandle class="ham-icon drag-accordion-icon">
                                    <i class="dots-grid-icon"></i>
                                </span>
                                <span
                                    class="accordion-index"
                                    [ngClass]="{ 'accordion-index-filled': noteAccordion.filled }"
                                >
                                    {{ getAccordionIndex(noteAccordion) }}
                                </span>
                                <ham-inline-table-cell-edit
                                    class="editable-title long-cell accordion-title"
                                    [value]="noteAccordion.title[reportLocale]"
                                    [isEditing]="noteAccordion.isEditing"
                                    (save)="onEditAccordionTitle($event, noteAccordion, accordionIndex)"
                                ></ham-inline-table-cell-edit>

                                <span
                                    class="ham-icon referencing-icon"
                                    [ngClass]="{ on: noteAccordion.referenceFlis?.length > 0, disabled: !noteAccordion.filled }"
                                    (click)="onNotesSectionReferencingButtonClick(accordionIndex)"
                                >
                                    <i class="bookmark-outline-icon"></i>
                                </span>

                                <span
                                    *ngIf="noteAccordion.isCorrect"
                                    hamIconShapes
                                    class="icon check-icon"
                                    icon="assets/hamIcons/check-circle.svg"
                                    [variant]="'transparent'"
                                    [size]="'regular'"
                                    stopPropagation
                                >
                                </span>

                                <span
                                    *ngIf="noteAccordion.isCorrect === false"
                                    hamIconShapes
                                    class="icon incorrect-icon"
                                    icon="assets/hamIcons/x-circle-red.svg"
                                    [variant]="'transparent'"
                                    [size]="'regular'"
                                    stopPropagation
                                >
                                </span>
                            </div>

                            <span class="accordion-icons">
                                <span
                                    hamIconShapes
                                    class="icon eye-icon"
                                    icon="assets/hamIcons/eye-outline.svg"
                                    [variant]="'transparent'"
                                    [size]="'regular'"
                                    [ngClass]="{ 'slash-through': isAccordionHidden(noteAccordion) }"
                                    (click)="onToggleAccordionVisibility(accordionIndex)"
                                    hamTooltip="{{
                                        isAccordionHidden(noteAccordion)
                                            ? ('aumico_notes_actions_show_accordion_tooltip' | i18next)
                                            : ('aumico_notes_actions_hide_accordion_tooltip' | i18next)
                                    }}"
                                    tooltipPosition="bottom"
                                    stopPropagation
                                >
                                </span>
                                <span
                                    hamIconShapes
                                    class="icon"
                                    icon="assets/hamIcons/trash-outline.svg"
                                    [variant]="'transparent'"
                                    [size]="'regular'"
                                    (click)="onDeleteAccordionClick(accordionIndex)"
                                    stopPropagation
                                ></span>

                                <span
                                    hamIconShapes
                                    class="icon"
                                    icon="assets/hamIcons/info-outline.svg"
                                    [variant]="'transparent'"
                                    [size]="'regular'"
                                    (click)="onInformationIconClicked($event, noteAccordion, accordionIndex)"
                                    stopPropagation
                                ></span>

                                <span
                                    *ngIf="!accordions.expanded"
                                    class="arrow-icon"
                                    hamIconShapes
                                    icon="assets/hamIcons/chevron-down.svg"
                                    [variant]="'transparent'"
                                    [size]="'regular'"
                                    (click)="accordions.onToggle()"
                                ></span>

                                <span
                                    *ngIf="accordions.expanded"
                                    hamIconShapes
                                    class="arrow-icon"
                                    icon="assets/hamIcons/chevron-up-outline.svg"
                                    [variant]="'transparent'"
                                    [size]="'regular'"
                                    (click)="accordions.onToggle()"
                                ></span>
                            </span>
                        </ng-container>
                    </div>

                    <!-- Body Content -->
                    <div accordion-body *ngIf="openAccordions[noteAccordion.name] || isGlobalResetInProgress">
                        <aumico-notes-components-list
                            [reportLocale]="reportLocale"
                            [index]="accordionIndex"
                            [componentData]="noteAccordion.data"
                            [delegate]="this"
                            [flis]="flisWithAccounts"
                            [languages]="languages"
                            [richTextFromInformationUpdate$]="richTextFromInformationUpdate$"
                            [annualReportDefaultSettings]="annualReportDefaultSettings"
                            [fxNotesContext]="fxNotesContext"
                            [fliFxStamps]="fliFxStamps"
                            [resetValuesFromMappingForAllComponents]="resetState[accordionIndex]"
                            [highlightTodos]="highlightTodos"
                            [autofillMode]="autofillMode"
                            [supportOperation]="supportOperation"
                            [notesNumberedTitles]="notesNumberedTitles ? notesNumberedTitles[accordionIndex]: []"
                            [balanceMappingTemplate]="balanceMappingTemplate"
                            [incomeMappingTemplate]="incomeMappingTemplate"
                            [rawBalanceMappingTemplate]="rawBalanceMappingTemplate"
                            [rawIncomeMappingTemplate]="rawIncomeMappingTemplate"
                            (onComponentDataChange)="onComponentDataChange($event.data, $event.componentIndex, accordionIndex)"
                            (onDeleteComponent)="onDeleteComponent($event, accordionIndex)"
                            (onDropComponents)="onDropComponent($event.previousIndex, $event.currentIndex, accordionIndex)"
                            (onTableReferenceChange)="onTableReferenceChange($event.data, $event.componentIndex, $event.tableIndex, accordionIndex)"
                            (onComponentReferenceChange)="onComponentReferenceChange($event.data, $event.componentIndex, accordionIndex)"
                        >
                        </aumico-notes-components-list>
                    </div>
                </ham-accordion-item>
            </ham-accordion>
        </div>
        <div *ngIf="showAddNewNotesAccordionSection" class="add-notes-accordion-section">
            <add-notes-accordion-section
                [supportOperation]="supportOperation"
                (noteAccordionAdded)="addNewAccordion($event)"
                (close)="closeAddNewNotesAccordionSection()"
            ></add-notes-accordion-section>
        </div>
    </div>

    <div class="alert alert-danger" *ngIf="isBackendReturnError">{{backendErrors | i18next }}</div>
    <div class="alert alert-warning" *ngIf="isClientReturnError && !notesAccordionData?.length">
        {{clientErrors | i18next }}
    </div>
</ng-container>

<ham-modal
    *ngIf="isCopyNotesStructureFromAnotherAnnualReportButtonClicked"
    [saveText]="'aumico_button_save' | i18next"
    (cancel)="isCopyNotesStructureFromAnotherAnnualReportButtonClicked = false"
    (save)="onCopyNotesStructureFromAnotherAnnualReportSaveButtonClicked()"
    [size]="'lg'"
    [disabled]="!selectedAnnualReportIdToCopyNotesStructureFrom"
>
    <aumico-annualReport-project-selection-list-component
        [data]="dialogData"
        (rowSelected)="onRowInModalSelected($event)"
        [currentLanguage]="currentLanguage"
    ></aumico-annualReport-project-selection-list-component>
</ham-modal>
